import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { TableContext } from "../../index";
import * as urlService from "../../view/urlService";

export const useRemediationTableHelper = () => {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const hardReload = (props = {}) => {
        setConfig({
            ...config,
            selected: [],
            selectAll: false,
            hardReload: true,
            lastUpdated: Date.now(),
            ...props
        });
        history.push({ pathname: '/remediation' });
    }

    const onRuleClick = () => {
        history.push({
            pathname: history.location.pathname,
            search: urlService.updateSort('rule')
        })
    }
    const onDeviceClick = () => {
        history.push({
            pathname: history.location.pathname,
            search: urlService.updateSort('device')
        })
    }
    const onSectionClick = () => {
        history.push({
            pathname: history.location.pathname,
            search: urlService.updateSort('sectionName')
        })
    }
    const onSubsectionClick = () => {
        history.push({
            pathname: history.location.pathname,
            search: urlService.updateSort('subsectionName')
        })
    }
    const onSeverityClick = () => {
        history.push({
            pathname: history.location.pathname,
            search: urlService.updateSort('severity')
        })
    }
    const onPreviousValidClick = () => {
        history.push({
            pathname: history.location.pathname,
            search: urlService.updateSort('previousValid')
        })
    }
    const onValidClick = () => {
        history.push({
            pathname: history.location.pathname,
            search: urlService.updateSort('valid')
        })
    }
    const onUserClick = () => {
        history.push({
            pathname: history.location.pathname,
            search: urlService.updateSort('user')
        })
    }
    const onDateClick = () => {
        history.push({
            pathname: history.location.pathname,
            search: urlService.updateSort('remediateStartTime')
        })
    }


    const updatePagination = (page, size) => {
        history.push(
            {
                pathname: history.pathname,
                search: urlService.updatePagination(page, size)
            }
        )
    }

    return {
        hardReload,
        onRuleClick,
        onDeviceClick,
        onSectionClick,
        onSubsectionClick,
        onSeverityClick,
        onPreviousValidClick,
        onValidClick,
        onUserClick,
        onDateClick,
        updatePagination
    }
}
